// extracted by mini-css-extract-plugin
export default {"container":"Checkbox-module--container--C9r4g","children":"Checkbox-module--children--Iy6v0","check":"Checkbox-module--check--nVZV6"};